import { Directive, ElementRef, HostListener, Renderer2, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appMaxDate]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MaxDateDirective,
      multi: true,
    },
  ],
})
export class MaxDateDirective implements Validator {
  @Input('appMaxDate') config!: { maxDate: string | Date | null | undefined };
  private control!: AbstractControl;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit() {
    this.setMaxDate();
  }

  private setMaxDate() {
    const maxDate = this.config.maxDate;
    if (maxDate) {
      const formattedDate = new Date(maxDate).toISOString().split('T')[0];
      this.renderer.setAttribute(this.el.nativeElement, 'max', formattedDate);
    } else {
      this.renderer.removeAttribute(this.el.nativeElement, 'max');
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.control = control;

    if (!control.value) {
      return null;
    }

    if (this.config.maxDate) {
      const inputDate = new Date(control.value);
      const maxDate = new Date(this.config.maxDate);

      return inputDate.getTime() > maxDate.getTime()
        ? { maxDate: { requiredDate: this.config.maxDate, actualDate: control.value } }
        : null;
    }
    return null;
  }

  @HostListener('blur')
  onBlur() {
    if (this.control && this.control.value) {
      const inputDate = new Date(this.control.value);
      
      if (this.config.maxDate) {
        const maxDate = new Date(this.config.maxDate);

        if (inputDate.getTime() > maxDate.getTime()) {
          this.clearInput();
        }
      }
    }
  }

  private clearInput() {
    this.control.setValue('');
    this.renderer.setProperty(this.el.nativeElement, 'value', '');
    this.el.nativeElement.focus();
  }
}
